import { observer } from 'mobx-react'
import * as React from 'react'
import styled from 'styled-components'
import { Button } from '../../atoms/Button'
import { FieldNo } from '../../atoms/FieldNo'
import { HideTablet } from '../../atoms/HideTablet'
import { IntakeStepCol } from '../../atoms/IntakeStepCol'
import { IntakeStepContainer } from '../../atoms/IntakeStepContainer'
import { IntakeStepNoColTablet } from '../../atoms/IntakeStepNoColTablet'
import { Label } from '../../atoms/Label'
import { RadioButton } from '../../atoms/RadioButton'
import {
  GetOwnIntakeQuery_getOwnIntake, UpdateOwnIntakeMutationVariables,
} from '../../schema/schemaTypes'

interface IProps {
  id: string
  active: boolean
  handleSubmit: (vars: UpdateOwnIntakeMutationVariables, goToNext?: boolean) => void
  intake: GetOwnIntakeQuery_getOwnIntake
  isCompleted: boolean
  label: string
  name: string
  no: number
  correctText: string
  wrongText: string,
    crossOutIndexes?: number[],
  options?: Array<{ value: any, label: string, correct: boolean }>
}

@observer
export class ReviewStepRadioButtons extends React.Component<IProps> {
  public render () {
    const {
      correctText,
      wrongText,
      active,
      handleSubmit,
      intake,
      id,
      isCompleted,
      label,
      name,
      no,
      options,
      crossOutIndexes,
    } = this.props

    const indexes = crossOutIndexes || []

    return (
      <IntakeStepContainer id={id} active={active}>
        <IntakeStepNoColTablet>
          <FieldNo checked={isCompleted}>{no}</FieldNo>
        </IntakeStepNoColTablet>
        <IntakeStepCol>
          <Label><HideTablet><FieldNo checked={isCompleted}>{no}</FieldNo></HideTablet>{label}</Label>
          {(options || []).map((o, index) => (
            <div>
              <RadioButton disabled={!active || isCompleted }
                crossedOut={isCompleted && indexes.includes(index)}
                // tslint:disable-next-line:jsx-no-lambda
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSubmit({ [name]: o.value }, false)}
                id={`intake-${id}-options-${o.value}`} name={`intake-${id}-options`} label={o.label}
                checked={intake[name] === o.value} key={o.value}
              />
              <br />
              {intake[name] === o.value && o.correct && <FeedbackRight>{correctText}</FeedbackRight>}
              {intake[name] === o.value && !o.correct && <FeedbackWrong>{wrongText}</FeedbackWrong>}
            </div>
          ))}
          {/* <FieldError /> */}
          {intake[name] !== null && (
            <div>
              {/* tslint:disable-next-line:jsx-no-lambda */}
              <Button style={{ marginTop: 15 }} onClick={() => handleSubmit({})}>{process.env.REACT_APP_LANGUAGE === 'es' ? 'PROXIMO' : 'NEXT'}</Button>
            </div>
          )}
        </IntakeStepCol>
      </IntakeStepContainer>
    )
  }
}


export enum ANSWER_INDEX {
    A = 0,
    B = 1,
    C = 2,
    D = 3,
}


const FeedbackRight = styled.span`
  padding: 5px 17px;
  background: #15E08C;
  margin-left: 40px;
  border-radius: 100px;
  color: #fff;
`

const FeedbackWrong = styled(FeedbackRight)`
  background: #f8373e;
  margin-left: 40px;
`



// WEBPACK FOOTER //
// ./src/organisms/Intakes/ReviewStepRadioButtons.tsx